import React from 'react'

export default function UpOutlined(props) {
  return (
    <svg
      width={props.width ? props.width : '24'}
      height={props.height ? props.height : '24'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.9998 8.49982C12.1314 8.49906 12.2619 8.52428 12.3837 8.57405C12.5056 8.62381 12.6164 8.69714 12.7098 8.78982L16.7098 12.7898C16.8031 12.8831 16.877 12.9937 16.9275 13.1156C16.9779 13.2374 17.0039 13.368 17.0039 13.4998C17.0039 13.6317 16.9779 13.7622 16.9275 13.8841C16.877 14.0059 16.8031 14.1166 16.7098 14.2098C16.6166 14.3031 16.5059 14.377 16.3841 14.4275C16.2622 14.4779 16.1317 14.5039 15.9998 14.5039C15.868 14.5039 15.7374 14.4779 15.6156 14.4275C15.4937 14.377 15.3831 14.3031 15.2898 14.2098L11.9998 10.8998L8.69982 14.0798C8.60783 14.1821 8.49572 14.2643 8.37051 14.3213C8.2453 14.3783 8.10967 14.4088 7.97212 14.411C7.83457 14.4132 7.69804 14.387 7.57109 14.334C7.44413 14.281 7.32948 14.2024 7.23429 14.103C7.13911 14.0037 7.06544 13.8858 7.01789 13.7567C6.97035 13.6276 6.94996 13.4901 6.95798 13.3528C6.96601 13.2154 7.00229 13.0812 7.06455 12.9586C7.12681 12.8359 7.21371 12.7274 7.31982 12.6398L11.3198 8.77982C11.5027 8.6035 11.7458 8.50339 11.9998 8.49982Z'
        fill={props.color ? props.color : '#1D79FB'}
      />
    </svg>
  )
}
